<template lang="pug">
.VideoEditDeleteDialog
    v-menu()
        template(v-slot:activator='{ on, attrs }')
            v-btn.moreMenu(icon='' v-bind='attrs' v-on='on')
                v-icon mdi-dots-vertical
        v-card()
            v-list-item(dense @click='editContent = true')
                v-list-item-icon.mr-2
                    v-icon(color="primary" small) mdi-pencil
                v-list-item-title {{ $t('general.edit') }}
            v-list-item(dense @click='deleteDialog = true')
                v-list-item-icon.mr-2
                    v-icon(color="error" small) mdi-delete
                v-list-item-title.red--text {{ $t('general.delete') }}
    v-dialog(v-model="editContent" max-width="700")
        v-card.card.rounded-lg(flat)
            v-card-title.text-capitalize {{ $t('videoDetails.editVideo', {element: video.element.toLowerCase()}) }}
            v-card-text
                v-form(ref="videoEditForm", v-model="valid", lazy-validation="")
                      v-text-field.rounded-lg(
                        v-model="editedVideo.title",
                        :counter="60",
                        :rules="nameRules",
                        :label="$t('clips.forms.title')",
                        filled
                        rounded
                      )
                      v-textarea.rounded-lg(
                        v-model="editedVideo.description",
                        
                        :label="$t('clips.forms.description')",
                        :counter="400",
                        auto-grow,
                        rows="5",
                        row-height="30",
                        filled,
                        rounded
                      )
                      v-select.rounded-lg(
                        v-model="editedVideo.categoryIDs",
                        :items="allCategories",
                        item-text="title",
                        item-value="id",
                        deletable-chips,
                        multiple,
                        filled,
                        rounded
                        chips,
                        :label="$t('clips.categories')",
                      )
            v-card-actions.pa-4
                  v-spacer
                  v-btn.text-normal(
                    depressed
                    @click="cancel"
                  ) {{ $t('general.cancel') }}
                  v-btn.text-normal(
                    :disabled="!valid",
                    depressed,
                    :loading="loading",
                    ripple,
                    color="primary",
                    @click="submit"
                  ) {{ $t('general.save') }}
    v-dialog(v-model="deleteDialog" width="460")
        v-card.card.rounded-lg
            v-card-title
                | {{ $t('videoDetails.deleteVideo', {element: `'${video.title}'`}) }}
            v-card-text
                | {{ $t('videoDetails.deleteText', {element: `'${video.title}'`}) }}
            v-divider
            v-card-actions
                v-spacer
                v-btn.text-normal(depressed, @click="deleteDialog = false")
                    | {{ $t('general.cancel' )}}
                v-btn.text-normal(color="error", depressed, @click="deleteVideo(video)")
                    | {{ $t('general.delete') }}              

        
</template>

<script>
import { mapGetters, mapState } from "vuex";
import date from "@/utils/date";
import urlFormat from "@/utils/urlFormat";
import { nameRules, descriptionRules } from "@/utils/validations";
export default {
  name: "VideoEditDeleteDialog",
  data() {
    return {
      editedVideo: {},
      deleteDialog: false,
      loading: false,
      valid: true,
      editContent: false,
      nameRules,
      descriptionRules,
    };
  },
  computed: {
    ...mapGetters("videoAsset", {
      video: "selectedVideoAsset",
    }),
    ...mapState({
      allCategories: (state) => state.settings.categories,
    }),
  },
  mounted() {
    this.editedVideo = { ...this.video };
  },
  methods: {
    ...date,
    ...urlFormat,
    cancel() {
      this.editedVideo = { ...this.video };
      this.editContent = false;
    },
    submit() {
      if (this.$refs.videoEditForm.validate()) {
        const data = {
          ...this.video,
          title: this.editedVideo.title,
          description: this.editedVideo.description ?? "",
          categoryIDs: this.editedVideo.categoryIDs ?? [],
        };

        this.loading = true;
        this.$store.dispatch("videoAsset/UPDATE_VIDEO_ASSET", data).then(() => {
          this.editContent = false;
          this.loading = false;
        });
      }
    },
    deleteVideo({ id, element }) {
      this.$store
        .dispatch("videoAsset/DELETE_VIDEO_ASSET", { id, element })
        .then(() => {
          this.dialog = true;
          this.$router.go(-1);
        })
        .catch((e) => {
          console.log(e);
          this.dialog = true;
          this.$router.go(-1);
        });
    },
  },
};
</script>
